module.exports = __webpack_public_path__ + "img/enaira-green.25f32a26.svg";